import { render } from "./EvaluationCriteria.vue?vue&type=template&id=206461bc"
import script from "./EvaluationCriteria.vue?vue&type=script&lang=js"
export * from "./EvaluationCriteria.vue?vue&type=script&lang=js"

import "./EvaluationCriteria.vue?vue&type=style&index=0&id=206461bc&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__